import {
  type FC, type PropsWithChildren,
} from 'react';
import React from 'react';
import { ActiveBoundaryExtraFillContainer } from '~/sidebar/sidebarApps/mapTools/boundary/extraFills/activeBoundaryExtraFill.container';
import { useExtraFillsSelector } from '~/sidebar/sidebarApps/mapTools/boundary/extraFills/boundaryExtraFillSelectors';
import { useBoundaryTerritoryGroupsSelector } from '~/store/boundaryTerritoryGroups/boundaryTerritoryGroups.selectors';

type ActiveBoundaryExtraFillInfoProps = Readonly<{
  boundaryTerritoryGroupId: number;
}>;

export const ActiveBoundaryExtraFillsContainer: FC<PropsWithChildren<ActiveBoundaryExtraFillInfoProps>> = ({
  boundaryTerritoryGroupId,
  children,
}) => {
  const boundaryGroupExtraFills = useExtraFillsSelector(boundaryTerritoryGroupId) ?? [];
  const boundaryTerritoryGroups = useBoundaryTerritoryGroupsSelector();
  const boundaryTerritoryGroup = boundaryTerritoryGroups.find(
    group => group.boundaryTerritoryGroupId === boundaryTerritoryGroupId,
  );

  if (!boundaryTerritoryGroup) {
    return null;
  }

  return boundaryGroupExtraFills.map(fillInfo => {
    return (
      <ActiveBoundaryExtraFillContainer
        key={fillInfo.boundaryFillId}
        boundaryTerritoryGroup={boundaryTerritoryGroup}
        fillInfo={fillInfo}
      >
        {children}
      </ActiveBoundaryExtraFillContainer>
    );
  });
};
